import React from 'react'
import s from './TrayWidget.scss'
import { nodes } from '../Flow.data'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'

export default ({ nodeType }) => {
  const node = nodes[nodeType]
  return (
    <div
      className={cn(s.trayWidget, sLay['layout-row'], sLay['layout-align-start-center'])}
      draggable
      onDragStart={event => {
        event.dataTransfer.setData('storm-diagram-node', JSON.stringify({ nodeType }))
      }}
    >
      <node.icon size={24} style={{ marginRight: '10px' }} />
      {node.label}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/TrayWidget/TrayWidget.jsx